import type { NovaEvent } from "@nova/types";
import type { AppHostServiceEventOriginator } from "./originator";
import type { MailboxInfo } from "owa-client-types";

export const StartShareContactsAsVCardEventType = "shareContactsAsVCard" as const;

export interface StartShareContactsAsVCardEvent extends NovaEvent<StartShareContactsAsVCardEventData> {
    originator: typeof AppHostServiceEventOriginator;
    type: typeof StartShareContactsAsVCardEventType;
    data: () => StartShareContactsAsVCardEventData;
}

export interface StartShareContactsAsVCardEventData {
    personaNodeIds: string[];
    mailboxInfo: MailboxInfo;
}
